// Редът „Общо" на решетката „Инвентаризация": в полето на етикета —
// „Излишъци +x · Липси −y (с ДДС …)" (нето + брутото на разликата), под
// колоната „Стойност" — нетната разлика (излишъци + липси, знакова и оцветена
// като колоната). Един ред, както „Общо" навсякъде. Брутото живее САМО тук —
// редовете носят една стойност (нето).
// Без ДДС (нерегистрирана фирма / 0 %) брутото е същото число и не се пише.
// Лепнат за дъното на картата (`WorksheetTotalsRow`).
import { useTranslation } from "react-i18next";
import {
  TotalsLabelCell,
  WorksheetTotalsRow,
} from "../../components/worksheet/WorksheetTotalsRow";
import { LINE_GRID_CLASS, LINE_GRID_COLUMN_COUNT } from "./stocktakeWorksheetShared";
import { formatSignedMoney, grossDiffers, signedToneClass } from "./stocktakeMeta";

export type StocktakeTotals = {
  net: number;
  gross: number;
  counted: number;
  surplus: number;
  shortage: number;
  // нетото на излишъците (≥ 0) и на липсите (≤ 0) поотделно
  surplusNet: number;
  shortageNet: number;
};

export const StocktakeTotalsRow = ({ totals }: { totals: StocktakeTotals }) => {
  const { t } = useTranslation();
  // „Излишъци +120.00" — сумата е в тона на разликата
  const part = (label: string, value: number, toneClass: string) => (
    <span className="whitespace-nowrap">
      {label} <b className={`font-sheet font-bold ${toneClass}`}>{formatSignedMoney(value)}</b>
    </span>
  );
  return (
    <WorksheetTotalsRow gridClass={LINE_GRID_CLASS} columnCount={LINE_GRID_COLUMN_COUNT}>
      {/* # · Продукт · Търсено · Намерено · Разлика · Ед. цена */}
      <TotalsLabelCell
        span={LINE_GRID_COLUMN_COUNT - 1}
        title={t("inventoryPage.total")}
        detail={
          <>
            {part(t("inventoryPage.stkTotalsSurplus"), totals.surplusNet, "text-ok-deep")}
            {" · "}
            {part(t("inventoryPage.stkTotalsShortage"), totals.shortageNet, "text-danger-ink")}
            {grossDiffers(totals.net, totals.gross) && (
              <span className="whitespace-nowrap font-sheet text-muted">
                {" "}
                {t("inventoryPage.stqTotalsWithVat", { value: formatSignedMoney(totals.gross) })}
              </span>
            )}
          </>
        }
      />
      {/* Стойност: нетната разлика; „(с ДДС …)" е в етикета — редът „Общо" е един ред */}
      <div className="flex min-w-0 items-center justify-end border-r border-shade-2 px-2.5 py-1">
        <span
          className={`whitespace-nowrap font-sheet text-[15px] font-bold tabular-nums ${signedToneClass(totals.net)}`}
        >
          {formatSignedMoney(totals.net)}
        </span>
      </div>
    </WorksheetTotalsRow>
  );
};

export default StocktakeTotalsRow;
